import { render, staticRenderFns } from "./ForumBreadcrumbs.vue?vue&type=template&id=00f70e88&scoped=true&"
import script from "./ForumBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ForumBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ForumBreadcrumbs.vue?vue&type=style&index=0&id=00f70e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f70e88",
  null
  
)

export default component.exports